import Head from 'next/head'

import { FaviconAsset, FaviconTagsProps, getAssetDefaults } from '@cash-web/favicon'

export const FaviconTags: React.FC<FaviconTagsProps> = ({ additionalAssets = [], include = {}, theme = 'default' }) => {
  const { appleTouchIcon = {}, ico = {}, manifest = {}, svg = {} } = include

  return (
    <Head>
      {appleTouchIcon && (
        <link
          key="favicon-apple-touch-icon"
          {...{ ...getAssetDefaults(FaviconAsset.AppleTouchIcon, theme), ...appleTouchIcon }}
        />
      )}
      {manifest && (
        <link key="favicon-manifest" {...{ ...getAssetDefaults(FaviconAsset.Manifest, theme), ...manifest }} />
      )}
      {ico && <link key="favicon-ico" {...{ ...getAssetDefaults(FaviconAsset.Ico, theme), ...ico }} />}
      {svg && <link key="favicon-svg" {...{ ...getAssetDefaults(FaviconAsset.Svg, theme), ...svg }} />}

      {additionalAssets.map(asset => (
        <link {...asset} key={asset.key} />
      ))}
    </Head>
  )
}
